import React, { useState } from 'react';
import { ButtonIcon, OutlinedButton } from '@prisjakt/ui/button/variants';
import { IconDropdownDown, IconDropdownUp } from '@prisjakt/ui/icon';
import { Modal } from 'src/areas/product/styles';
import { IconImageText, ModalInner } from './styles';
import { useAppContext } from 'src/components/app-context';
import { IFilterComponent } from './types';
import { TitleSmallText } from '@prisjakt/ui/text/variants';

export const ModalView: React.FC<IModalView> = props => {
  const { components } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const closeHandler = () => setVisible(false);
  const toggleHandler = () => setVisible(!visible);
  const { market, t } = useAppContext();

  const renderButtonLabel = () => {
    const singleComponentWithCustomButton =
      components.length === 1 && components[0].buttonLabelComponent;

    if (singleComponentWithCustomButton) {
      // For single variant selection
      return (
        <>
          {singleComponentWithCustomButton}
          <ButtonIcon>
            {visible ? <IconDropdownUp /> : <IconDropdownDown />}
          </ButtonIcon>
        </>
      );
    }
    return (
      <IconImageText>
        <img
          src={`${market.cdn}/g/rfe/illustrations/icon-color-wheel-20x20px.png`}
          srcSet={`${market.cdn}/g/rfe/illustrations/icon-color-wheel-20x20px.png 1x, ${market.cdn}/g/rfe/illustrations/icon-color-wheel-40x40px.png 2x`}
          alt=""
        />
        <TitleSmallText>
          {t('product', 'variants.select-variants')}
        </TitleSmallText>
      </IconImageText>
    );
  };

  return (
    <>
      <OutlinedButton onClick={toggleHandler} fullWidth>
        {renderButtonLabel()}
      </OutlinedButton>

      {visible && (
        <Modal
          isOpen
          onRequestClose={closeHandler}
          shouldShowCloseIcon
          verticalScroll
          width={526}
        >
          <ModalInner>
            {components.map(component => (
              <div key={component.key}>{component.selectorComponent}</div>
            ))}
          </ModalInner>
        </Modal>
      )}
    </>
  );
};

interface IModalView {
  components: IFilterComponent[];
}
